import React, { useContext, useState, useEffect, useMemo } from "react";
import {
  Box,
  Dialog,
  InputBase,
  Slide,
  Typography,
  useMediaQuery,
  styled,
  Grid,
  Container,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { formatUnits, parseUnits } from "viem";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import { formatUnits, parseUnits } from "@ethersproject/units";
import { AppContext } from "../utils";
import {
  bscPresaleAddress, defaultAddress,
} from "../ConnectivityAssets/environment";
import { HashLoader, RingLoader } from "react-spinners";
// import { StyledButton } from "../components/SmallComponents/AppComponents";
// import { bnb, logo, usdt, eth } from "../components/SmallComponents/Images";
import {
  bnbPresaleReadFunction,
  bnbPresaleWriteFunction,
  bnbUsdtReadFunction,
  bnbUsdtWriteFunction,
  bnbBusdReadFunction, bnbBusdWriteFunction,

} from "../ConnectivityAssets/hooks";
import { fetchBalance } from "@wagmi/core";

// import { StyledButton } from "../Components/SmallComponents/AppComponents";
// import { bnb, logo, usdt, eth } from "../Components/SmallComponents/Images";
// import ethPresaleAbi from "../ConnectivityAssets/ethPreSaleAbi.json";
// import bnbPresaleAbi from "../ConnectivityAssets/bnbPresaleAbi.json";
// import Web3 from "web3";
// import {
//   bscProvider,
//   ethProvider,
//   getContract,
//   voidSigners,
// } from "../ConnectivityAssets/multiNetwork";
// import { Contract } from "ethers";
import NetworkDialog from "../NetworkDialog";
import TimerCountDown from "../components/Timer";
import moment from "moment";
import Loading from "../components/SmallComponents/loading";
import { useWeb3Modal } from "@web3modal/react";
import { useNetwork, useSwitchNetwork } from "wagmi";
import { banmb, banner, bnb, busd, logo, usdt } from "../components/SmallComponents/Images";
import { StyledButton, StyledCurrencyButton, ToastNotify } from "../components/SmallComponents/AppComponents";
import CopyToClipboard from "react-copy-to-clipboard";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const TextInput = styled(InputBase)({
  "& .MuiInputBase-input": {
    height: "40px",
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Monroe-Regular",
    textAlign: "left",
    color: "green",
    backgroundColor: "transparent",
    paddingLeft: "15px",
    "&::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "&::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
});

/// handle number field

const handleKeyDown = (event) => {
  if (event.key === "ArrowUp" || event.key === "ArrowDown") {
    event.preventDefault();
  }
};
const handleWheel = (e) => {
  e.target.blur();
};
/// end handle number field
export default function MainSection() {
  let currentTime = moment().format("X");
  let stageEndTime = 1693292400;
  const matches = useMediaQuery("(max-width:700px)");
  const { account, connectedChainId } = useContext(AppContext);
  const { open } = useWeb3Modal();
  const { chain } = useNetwork();
  const { switchNetwork } = useSwitchNetwork();
  const [token, setToken] = useState("USDT");
  const [openDialog, setOpenDialog] = useState(false);
  const [enteredAmount, setEnteredAmount] = useState("");
  const [receivedTokens, setreceivedTokens] = useState("");
  const [totalSoldTokens, settotalSoldTokens] = useState(0);
  const [totalSupply, settotalSupply] = useState(0);
  const [totalSupplyPerPhase, settotalSupplyPerPhase] = useState(0);
  const [userPurchasedTokens, setuserPurchasedTokens] = useState(0);
  const [userPuchasedTokensToShow, setuserPuchasedTokensToShow] = useState(0);
  const [oneUSDTtoToken, setoneUSDTtoToken] = useState(0);
  const [oneBNBtoToken, setoneBNBtoToken] = useState(0);
  const [nextStagePrice, setnextStagePrice] = useState(0);
  const [presaleStage, setpresaleStage] = useState(0);
  const [balanceBUSD, setbalanceBUSD] = useState(0);
  const [hardCap, sethardCap] = useState(0);
  const [tokenPrice, settokenPrice] = useState(0);
  const [openNetworkChange, setopenNetworkChange] = useState(false);
  const [balanceUSDT, setbalanceUSDT] = useState(0);
  const [balanceBNB, setbalanceBNB] = useState(0);
  const [loading, setloading] = useState(false);
  const [loadingMain, setloadingMain] = useState(false);
  const [isClaimEnabled, setisClaimEnabled] = useState(false);
  const [raisedAmount, setRaisedAmount] = useState(0);
  const [callFunction, setCallFunction] = useState(true);
  const [complete, setComplete] = useState(false);
  const [progressBar, setProgessBar] = useState(0);
  const [referralAdd, setreferralAdd] = useState("");
  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });

  const toLocalFormat = (val) => {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  useEffect(() => {
    if (window.location.href.includes("?ref=")) {
      let getAddress = window.location.href.split("?ref=")[1];
      let final = getAddress.slice(0, 42);
      // localStorage.setItem("APE", final);
      setreferralAdd(final);
    }
  }, []);
  console.log(referralAdd, "referralAdd");
  useEffect(() => {
    (async () => {
      try {
        const nsp = await bnbPresaleReadFunction("nextPrice");
        setnextStagePrice(+formatUnits(nsp.toString(), 18));
        const saleStage = await bnbPresaleReadFunction("StageCount");
        setpresaleStage(+saleStage.toString());
        let perPhaseSupplyETH = await bnbPresaleReadFunction(
          "tokenForSell"
        );
        settotalSupplyPerPhase(+formatUnits(perPhaseSupplyETH.toString(), 18));
        let price = await bnbPresaleReadFunction("tokenPerUsd");
        settokenPrice(+formatUnits(price.toString(), 18));
        price = +formatUnits(price.toString(), 18);
        const rec1 = await bnbPresaleReadFunction("usdtToToken", [
          "1000000000000000000",
        ]);
        setoneUSDTtoToken(+formatUnits(rec1.toString(), 18));
        const rec3 = await bnbPresaleReadFunction("NativeToToken", [
          "1000000000000000000",
        ]);
        setoneBNBtoToken(+formatUnits(rec3.toString(), 18));
        const supplyTotal = await bnbPresaleReadFunction("totalSupply");
        const soldTotal = await bnbPresaleReadFunction("soldToken");
        let total =
          +formatUnits(soldTotal.toString(), 18);
        total = parseFloat(total).toFixed(0);
        settotalSoldTokens(toLocalFormat(total));
        let hardCap = +formatUnits(supplyTotal.toString(), 18) / +price;
        hardCap = parseFloat(hardCap).toFixed(0);
        sethardCap(toLocalFormat(hardCap));
        let supp = +formatUnits(supplyTotal.toString(), 18);
        supp = parseFloat(supp).toFixed(0);
        settotalSupply(toLocalFormat(supp));
        ///////////// Raised Total
        const raised = await bnbPresaleReadFunction("amountRaised");
        let usdtRaised = await bnbPresaleReadFunction(
          "amountRaisedUSDT"
        );
        usdtRaised = +formatUnits(usdtRaised.toString(), 18);
        let busdRaised = await bnbPresaleReadFunction(
          "amountRaisedBUSD"
        );
        busdRaised = +formatUnits(busdRaised.toString(), 18);
        const currentPriceBNB = await bnbPresaleReadFunction(
          "getLatestPrice"
        );
        let bnbToUsdt =
          +formatUnits(raised.toString(), 18) *
          +formatUnits(currentPriceBNB.toString(), 8);
        let totalRaised =
          +usdtRaised + +bnbToUsdt + +busdRaised;
        totalRaised = parseFloat(totalRaised).toFixed(0);
        setRaisedAmount(totalRaised);
        const claimEnabled = await bnbPresaleReadFunction("enableClaim");
        setisClaimEnabled(claimEnabled);
        setCallFunction(false);
      } catch (error) {
        setCallFunction(false);
        console.log(error, "ERROR VoidSigner Data");
      }
    })();
  }, [account, callFunction]);
  console.log(userPurchasedTokens, "userPurchasedTokens");
  useEffect(() => {
    if (account) {
      (async () => {
        try {
          const bnbBal = await fetchBalance({
            address: account,
          });
          let balBNB = parseFloat(
            +formatUnits(bnbBal?.value?.toString(), 18)
          ).toFixed(4);
          setbalanceBNB(toLocalFormat(+balBNB));
          const balance = await bnbUsdtReadFunction("balanceOf", [account]);
          let usdtBal = parseFloat(
            +formatUnits(balance.toString(), 18)
          ).toFixed(2);
          setbalanceUSDT(toLocalFormat(+usdtBal));
          const balanceBusd = await bnbBusdReadFunction("balanceOf", [account]);
          let busdBal = parseFloat(
            +formatUnits(balanceBusd.toString(), 18)
          ).toFixed(2);
          setbalanceBUSD(toLocalFormat(+busdBal));

          const user = await bnbPresaleReadFunction("users", [account]);
          setuserPurchasedTokens(
            +formatUnits(user[3].toString(), 18)
          );
          let totalToken =
            formatUnits(user[3].toString(), 18);
          totalToken = parseFloat(totalToken).toFixed(0);
          setuserPuchasedTokensToShow(toLocalFormat(totalToken));
          setCallFunction(false);
        } catch (error) {
          setCallFunction(false);
          console.log(error);
        }
      })();
    }
  }, [account, connectedChainId, callFunction]);

  const buyHadler = async () => {
    if (account) {
      if (!enteredAmount) {
        setAlertState({
          open: true,
          message: `Error! Please enter a amount`,
          severity: "error",
        });
      } else if (enteredAmount <= 0) {
        setAlertState({
          open: true,
          message: `Error! Please enter a valid amount`,
          severity: "error",
        });
      }
      else if (+currentTime > +stageEndTime) {
        setAlertState({
          open: true,
          message: `Error! Please wait for the next stage`,
          severity: "error",
        });
      }
      else if (+totalSupplyPerPhase <= (+totalSoldTokens + +receivedTokens)) {
        setAlertState({
          open: true,
          message: `Error! You can purchase ${+totalSupplyPerPhase - +totalSoldTokens} Tokens or wait for the next stage`,
          severity: "error",
        });
      }
      else {
        try {
          let refAdd = referralAdd ? referralAdd : defaultAddress;
          console.log(refAdd, "refAdd");
          setloading(true);
          if (token === "USDT") {
            if (+enteredAmount > +balanceUSDT) {
              setAlertState({
                open: true,
                message: `Error! You don't hace enough balance`,
                severity: "error",
              });
            } else {
              let allowance = await bnbUsdtReadFunction("allowance", [
                account,
                bscPresaleAddress,
              ]);
              if (+formatUnits(allowance.toString()) < +enteredAmount) {
                await bnbUsdtWriteFunction("approve", [
                  bscPresaleAddress,
                  "9999999999999999999999999999999",
                ]);
              }
              await bnbPresaleWriteFunction("buyTokenUSDT", [
                refAdd,
                parseUnits(enteredAmount.toString(), 18),

              ]);
              setComplete(true);
            }

          } else if (token === "BUSD") {
            if (+enteredAmount > +balanceBUSD) {
              setAlertState({
                open: true,
                message: `Error! You don't hace enough balance`,
                severity: "error",
              });
            } else {
              let allowance = await bnbBusdReadFunction("allowance", [
                account,
                bscPresaleAddress,
              ]);
              if (+formatUnits(allowance.toString()) < +enteredAmount) {
                await bnbBusdWriteFunction("approve", [
                  bscPresaleAddress,
                  "9999999999999999999999999999999",
                ]);
              }
              await bnbPresaleWriteFunction("buyTokenBUSD", [
                refAdd,
                parseUnits(enteredAmount.toString(), 18),
              ]);
              setComplete(true);
            }
          }
          else {
            if (+enteredAmount > +balanceBNB) {
              setAlertState({
                open: true,
                message: `Error! You don't hace enough balance`,
                severity: "error",
              });
            } else {
              await bnbPresaleWriteFunction(
                "buyToken",
                [refAdd],
                parseUnits(enteredAmount.toString(), 18).toString()
              );
              setComplete(true);
            }
          }
          setEnteredAmount("");
          setCallFunction(true);
          // initProgress();
          setloading(false);
        } catch (error) {
          setloading(false);
          setAlertState({
            open: true,
            message: error?.shortMessage,
            severity: "error",
          });
        }
      }
    } else {
      setAlertState({
        open: true,
        message: `Error! Please connect your wallet.`,
        severity: "error",
      });
    }
  };
  useEffect(() => {
    const calculator = async () => {
      try {
        if (token === "USDT" || token === "BUSD") {
          let tokenUSDT = +oneUSDTtoToken * +enteredAmount;
          setreceivedTokens(tokenUSDT);
        } else {
          let tokenbnb = +oneBNBtoToken * +enteredAmount;
          setreceivedTokens(tokenbnb);
        }
      } catch (error) { }
    };
    if (+enteredAmount > 0) {
      calculator();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enteredAmount, token]);

  useEffect(() => {
    (async () => {
      try {
        const totalSold = await bnbPresaleReadFunction("soldToken");
        const supply = await bnbPresaleReadFunction("totalSupply");
        let prog =
          (+formatUnits(totalSold.toString(), 18) /
            +formatUnits(supply.toString(), 18)) *
          100;
        setProgessBar(+prog);
        setCallFunction(false);
      } catch (error) {
        setCallFunction(false);
        console.log(error);
      }
    })();
  }, [connectedChainId, callFunction]);

  const claimHandler = async () => {
    if (account) {
      if (!isClaimEnabled) {
        setAlertState({
          open: true,
          message: `You can claim tokens after presale will end.`,
          severity: "error",
        });
      } else {
        try {
          setloadingMain(true);
          await bnbPresaleWriteFunction("claimTokens");
          setloadingMain(false);
          setAlertState({
            open: true,
            message: `You have Successfully claimed $APE Tokens`,
            severity: "success",
          });
          setCallFunction(true);
        } catch (error) {
          setloadingMain(false);
          setAlertState({
            open: true,
            message: error?.shortMessage,
            severity: "error",
          });
        }
      }
    } else {
      setAlertState({
        open: true,
        message: `Error! Please connect your wallet.`,
        severity: "error",
      });
    }
  };
  return (
    <Box >
      <ToastNotify alertState={alertState} setAlertState={setAlertState} />
      <Loading loading={loadingMain} />
      <NetworkDialog
        openChangeNetwork={openNetworkChange}
        setopenChangeNetwork={setopenNetworkChange}
        connectedChainId={connectedChainId}
      />
      <Dialog
        // fullWidth
        open={openDialog}
        TransitionComponent={Transition}
        sx={{
          zIndex: 10,
          "& .MuiPaper-root": {
            backgroundColor: "#101507",
            width: matches ? "100%" : "30%",
          },
        }}
      >
        <Box
          sx={{
            borderRadius: "10px",
            height: "100%",
          }}
        >
          <Box
            py={2}
            pl={3}
            pr={1}
            sx={{
              backgroundImage:
                "linear-gradient(90deg, #E2C811 30%, #5CA800 100%)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              fontSize="22px"
              fontFamily="Monroe-Regular"
              fontWeight="700"
              sx={{ fontSize: "18px" }}
              color="#ffffff"
            >
              Exchange
            </Box>
            <CloseIcon
              onClick={() => {
                setEnteredAmount("");
                setOpenDialog(!openDialog);
                setComplete(false);
              }}
              style={{
                cursor: "pointer",
                color: "#000000",
              }}
            />
          </Box>
          {loading ? (
            <Box
              display="flex"
              alignItems="center"
              flexDirection="column"
              py={3}

            >
              <HashLoader color="#ffffff" size={170} />
              <Box
                textAlign="center"
                mt={6}
                fontSize="15px"
                fontWeight="600"
                color="#ffffff"
                fontFamily="Monroe-Regular"
              >
                YOUR TRANSACTION IS IN PROGRESS <br />
                PLEASE WAIT
              </Box>
            </Box>
          ) : complete ? (
            <Box p={2} textAlign="center" color="#fff">
              <CheckCircleIcon sx={{ color: "#57CA5C", fontSize: "100px" }} />
              <Typography
                fontFamily="Monroe-Regular"
                color="lightGray"
                variant="body1"
                fontWeight="600"
              >
                YOUR PURCHASE HAS BEEN SUCCESSFUL!
              </Typography>
            </Box>
          ) : (
            <Box py={3} px={2} bgcolor="#bbff67">
              <Typography
                variant="body1"
                fontSize="15px"
                fontWeight="400"
                color="green"
                textAlign="right"
                fontFamily="Monroe-Regular"
              >
                Balance:{" "}
                {token === "USDT"
                  ? balanceUSDT
                  : token === "BUSD"
                    ? balanceBUSD
                    : balanceBNB}
              </Typography>
              <Box
                sx={{
                  border: "1px solid #212529",
                  borderRadius: "8px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                mt={1}
                pr={1}
              >
                <TextInput
                  fullWidth
                  placeholder="Enter amount"
                  type="number"
                  onKeyDown={handleKeyDown}
                  onWheel={handleWheel}
                  value={enteredAmount}
                  onChange={(e) => setEnteredAmount(e.target.value)}
                />

                <img
                  src={token === "USDT" ? usdt : token === "BNB" ? bnb : busd}
                  alt=""
                  style={{
                    marginRight: "4px",
                    width: "35px",
                  }}
                />
              </Box>
              <Box mt={2}>
                <Box
                  sx={{
                    border: "1px solid #212529",
                    borderRadius: "8px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  mb={2}
                  mt={1}
                  pr={1}
                >
                  <TextInput
                    fullWidth
                    placeholder="You will get"
                    type="number"
                    onKeyDown={handleKeyDown}
                    onWheel={handleWheel}
                    value={
                      +enteredAmount > 0
                        ? parseFloat(receivedTokens).toFixed(2)
                        : ""
                    }
                  />
                  <img
                    src={logo}
                    alt=""
                    style={{
                      marginRight: "4px",
                      width: "35px",
                    }}
                  />
                </Box>
              </Box>
              <StyledButton width="100%" onClick={() => buyHadler()}>
                Buy now
              </StyledButton>
            </Box>
          )}
        </Box>
      </Dialog>

      <Box sx={{
        backgroundImage: `url(${matches ? banmb : banner})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        height: matches ? "100%" : "130vh"
      }} py={10}>

        {/* <img
                src="wp-content/uploads/2022/10/banner.jpg"
                alt=""
                className="w-100 d-lg-block d-md-block d-sm-none d-none"

              /> */}
        <Container maxWidth="xl">
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={12} md={6}>
              <div style={{ textAlign: "center", marginTop: matches ? "70px" : "80px" }}>
                <strong style={{
                  font: matches ? "normal 60.06px/71px 'Monroe-Bold'" : "normal 84.06px/96px 'Monroe-Bold'",
                  textTransform: "uppercase",
                  color: "#d5fc04",
                  display: "block",
                  background: "#d5fb05",
                  background: "-webkit-linear-gradient(to right, #d5fb05, #c0db31)",
                  background: "linear-gradient(to right, #d5fb05, #c0db31)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                  textShadow: "-4px 5px 62px #d5fb05",
                }}>Ape Army</strong>
                <b style={{
                  font: matches ? "normal 40.06px/51px 'Monroe-Bold'" : "normal 71.17px/81px 'MyriadArabic-Bold'",
                  textTransform: "uppercase",
                  color: "#fff"
                }}>
                  <em style={{
                    font: matches ? "normal 20.83px/32px 'Monroe-Bold'" : "normal 43.83px/53px 'Monroe-Bold'",
                    textTransform: "uppercase",
                    color: "#fff"
                  }}>Hunt, Kill &amp; Play 2 Earn</em>
                </b>
                <p style={{
                  font: "normal 16.19px/24.48px 'Montserrat-Regular'",
                  color: "#fff"
                }}>
                  Welcome to the world's first P2E crypto coin dedicated to fighting ape extinction.
                  <br />
                  Immerse yourself in action-packed ape-themed games and actively contribute to preserving these magnificent creatures. Join our platform and make a real difference while enjoying thrilling adventures!
                </p>

                <ul className="readsosul">
                  <li>
                    <a
                      href="whitepaper.pdf"
                      className="read-white"
                      target="_blank"
                    >
                      <i className="fa-solid fa-star" /> Read Whitepaper{" "}
                      <i className="fa-solid fa-star" />
                    </a>
                  </li>
                  <li>
                    <ul className="sos_icons">
                      <li>
                        <a
                          href="https://t.me/ApeArmyPortal"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa-brands fa-telegram" />
                        </a>
                      </li>

                      <li>
                        <a href="https://twitter.com/ApeArmyOfficial" target="_blank">
                          <i className="fa-brands fa-twitter" />
                        </a>
                      </li>
                    </ul>

                  </li>
                </ul>
              </div>
            </Grid>
            <Grid item xs={12} md={6} >
              <div style={{ width: matches ? "90%" : "35%" }} className="presaleclpbx" >
                <TimerCountDown time={stageEndTime} />
                <h4 style={{ fontSize: "25px", marginTop: "-10px" }}>Don't Miss the Presale!</h4>

                <p>
                  <em>Buy Now Before Price Increases</em>

                </p>
                <h4 style={{ fontSize: "20px" }}>STAGE {presaleStage > 0 ? presaleStage : ""}</h4>
                <strong>
                  1 $APE = ${+tokenPrice > 0 ? 1 / +tokenPrice : 0}
                </strong>
                <p>
                  Next Stage Price $
                  {+nextStagePrice > 0 ? 1 / +nextStagePrice : 0}
                </p>
                <div className="meter">
                  <span style={{ width: `${progressBar + 6.5}%` }}></span>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "10%",
                      left: "43%",
                      color: "#ffffff",
                      fontSize: "20px",
                      fontWeight: "600",
                    }}
                  >
                    {parseFloat(progressBar + 6.5).toFixed(3)}%
                  </Box>
                </div>
                <ul>
                  <li>
                    Raised <br /> <u>${+raisedAmount + 58825}</u>
                    <br /> $900,000
                  </li>
                </ul>

                {account ? (
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <StyledCurrencyButton

                      width="32%"
                      style={{ cursor: "pointer", }}
                      onClick={() => {
                        setToken("BNB");
                        setOpenDialog(true);
                      }}
                    >
                      <img style={{ width: "25px", height: "25px", marginRight: "5px" }} src={bnb} alt="" /> BNB
                    </StyledCurrencyButton>
                    <StyledCurrencyButton
                      width="32%"
                      style={{ cursor: "pointer", }}
                      onClick={() => {
                        setToken("USDT");
                        setOpenDialog(true);
                      }}
                    >
                      <img style={{ width: "25px", height: "25px", marginRight: "5px" }} src={usdt} alt="" /> USDT
                    </StyledCurrencyButton>
                    <StyledCurrencyButton
                      width="32%"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setToken("BUSD");
                        setOpenDialog(true);
                      }}
                    >
                      <img style={{ width: "25px", height: "25px", marginRight: "5px" }} src={busd} alt="" />  BUSD
                    </StyledCurrencyButton>
                  </Box>
                ) : (
                  <a
                    style={{ cursor: "pointer", marginTop: "16px" }}
                    onClick={async () => await open()}
                    className="connect-wall"
                  >
                    CONNECT WALLET
                  </a>
                )}
                {isClaimEnabled ? (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    style={{ cursor: "pointer", marginTop: "12px" }}
                    onClick={() => claimHandler()}
                    className="connect-wall"
                  >
                    CLAIM {userPuchasedTokensToShow} $APE
                  </a>
                ) : null}
                {account && +connectedChainId !== 56 ? <ul> <li
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    switchNetwork?.(
                      56
                    );
                  }}
                >
                  <u>
                    Switch Network to Binance

                  </u>
                </li>
                </ul> : null} :


                <p>
                  Your purchased $APE: <br />{" "}
                  <em>{userPuchasedTokensToShow}</em>
                </p>
                <Box
                  sx={{
                    pl: 1,
                    background: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                  borderRadius="0px"
                  mt={2}
                >
                  <Typography
                    sx={{
                      fontFamily: "Monroe-Regular",
                      fontWeight: 400,
                      fontSize: "15px",
                      color: "#000000 !important",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {account
                      ? window.location.origin + "/?ref=" + account
                      : "Connect wallet For referral link"}
                  </Typography>
                  {account ? (
                    <CopyToClipboard
                      text={window.location.origin + "/?ref=" + account}
                      onCopy={() => {
                        setAlertState({
                          open: true,
                          message: `Refferal Link Copied.`,
                          severity: "success",
                        });
                      }}
                    >
                      <Box
                        sx={{
                          background:
                            "radial-gradient(145.24% 943.2% at 7.91% 50%, #89A600 0%, #CFF112 40%)",
                          borderRadius: "0px",
                          fontSize: "12px",
                          color: "#ffffff",
                          p: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <ContentCopyIcon />
                      </Box>
                    </CopyToClipboard>
                  ) : (
                    <Box
                      sx={{
                        background:
                          "radial-gradient(145.24% 943.2% at 7.91% 50%, #89A600 0%, #CFF112 40%)",
                        borderRadius: "0px",
                        fontSize: "12px",
                        color: "#ffffff",
                        p: "10px",
                        cursor: "no-drop",
                      }}
                    >
                      <ContentCopyIcon />
                    </Box>
                  )}
                </Box>
                <p style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "10px" }}>
                  Refer friends, earn 10% commission instantly!
                  <a
                    href="referral.pdf"
                    target="_blank"
                  >
                    <Box
                      sx={{
                        background:
                          "radial-gradient(145.24% 943.2% at 7.91% 50%, #89A600 0%, #CFF112 40%)",
                        borderRadius: "0px",
                        fontSize: "13px",
                        color: "#ffffff",
                        p: "10px",
                        fontFamily: "Monroe-Regular",
                        cursor: "pointer"
                      }}
                    >
                      Learn More
                    </Box>
                  </a>
                </p>

              </div>
            </Grid>
          </Grid>
        </Container>
        <div className="mobgrup w-100 d-lg-none d-md-none d-sm-block d-block">
          <img
            src="wp-content/themes/ogarmytheme/assets/images/banmb1.png"
            alt=""
            className="w-100"
          />
          <span className="mobflg">
            <img
              src="wp-content/themes/ogarmytheme/assets/images/flg.png"
              alt=""
            />
          </span>
        </div>
      </Box>
    </Box>
  );
}
